import { SeverityBadge } from './SeverityBadge';
import type { BenchmarkReport } from '../../types/benchmark';

interface WorstFieldsTableProps {
  report: BenchmarkReport;
  limit?: number;
}

export function WorstFieldsTable({ report, limit = 10 }: WorstFieldsTableProps) {
  const worstFields = report.worst_fields.slice(0, limit);

  return (
    <div className="bg-white p-6 border rounded-lg">
      <h3 className="text-lg font-semibold mb-4">Champs problématiques</h3>

      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Champ
              </th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Score F1
              </th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Erreurs
              </th>
              <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Sévérité moy.
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {worstFields.map((field, index) => {
              const fieldDetails = report.by_field.find(f => f.field === field.field);
              const avgSeverity = fieldDetails?.avg_severity || 0;

              return (
                <tr key={index} className="hover:bg-gray-50">
                  <td className="px-4 py-3 text-sm font-medium text-gray-900">
                    {field.field}
                  </td>
                  <td className="px-4 py-3 text-sm">
                    <span className={`font-semibold ${Number(field.f1) < 0.7 ? 'text-red-600' : Number(field.f1) < 0.85 ? 'text-orange-600' : 'text-yellow-600'}`}>
                      {Number(field.f1).toFixed(3)}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-500">
                    {field.error_count}
                  </td>
                  <td className="px-4 py-3 text-sm">
                    <SeverityBadge severity={Math.round(Number(avgSeverity))} showLabel={false} />
                    <span className="ml-2 text-gray-600">{Number(avgSeverity).toFixed(1)}</span>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
